import { FilterTypes } from '@/components/Task/types'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { useConfigStore } from './useConfigStore'

export interface UIState {
  checkboxes: { 
    [listId: string]: {
      [checkboxId: string]: boolean
    }
  },
  listOrder: {
    [accountId: string]: string[] // Array of list IDs in order
  },
  filters: Partial<Record<FilterTypes, any>>, 
  setCheckbox: (listId: string, checkboxId: string, isChecked: boolean) => void,
  setListOrder: (accountId: string, listIds: string[]) => void,
  moveList: (accountId: string, fromIndex: number, toIndex: number) => void,
  setFilter: (filter: FilterTypes, value: any) => void,
  layout: "list" | "grid" | "horizontal",
  setLayout: (layout: "list" | "grid" | "horizontal") => void,
}

const initialFilters: Partial<Record<FilterTypes, any>> = {
  search: "",
  upcoming: false,
  past: false,
  needsDate: false,
}

const useUIStore = create<UIState>()(
  devtools(
    (set) => ({
      checkboxes: {},
      listOrder: {},
      filters: initialFilters,
      setFilter: (filter, value) => set(state => ({ filters: { ...state.filters, [filter]: value } }), false, 'setFilter'),
      setCheckbox: (listId, checkboxId, isChecked) =>
        set(state => ({
          checkboxes: {
            ...state.checkboxes,
            [listId]: {
              ...state.checkboxes[listId],
              [checkboxId]: isChecked
            }
          }
        }), false, 'setCheckbox'),
      setListOrder: (accountId, listIds) => {
        set(state => ({
          listOrder: {
            ...state.listOrder,
            [accountId]: listIds
          }
        }), false, 'setListOrder')
        useConfigStore.getState().setListOrder(accountId, listIds)
      },
      moveList: (accountId, fromIndex, toIndex) => {
        let newOrder: string[] = [];
        set(state => {
          const currentOrder = state.listOrder[accountId] || [];
          newOrder = [...currentOrder];
          const [movedItem] = newOrder.splice(fromIndex, 1);
          newOrder.splice(toIndex, 0, movedItem);
          
          return {
            listOrder: {
              ...state.listOrder,
              [accountId]: newOrder
            }
          };
        }, false, 'moveList')
        useConfigStore.getState().setListOrder(accountId, newOrder)
      },
      layout: "grid",
      setLayout: (layout) => {
        set({ layout }, false, 'setLayout')
        useConfigStore.getState().setLayout(layout)
      },
    }),
    { name: 'UI-Store' }
  )
);

export default useUIStore;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
window.store = useUIStore